var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { API } from 'globals/api';
import { DEVICES_END_POINTS } from 'globals/apiEndPoints';
/**
 * @description method to fetch all device details
 * @function getDevicesService
 * @param {T} params
 */
export function getDevicesService(params) {
    return __awaiter(this, void 0, void 0, function () {
        var response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, API({
                            url: DEVICES_END_POINTS.GET_DEVICES,
                            params: params,
                            method: 'get',
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
                case 2:
                    e_1 = _a.sent();
                    return [2 /*return*/, e_1];
                case 3: return [2 /*return*/];
            }
        });
    });
}
/**
 * @description method to fetch extra device details
 * @function getDevicesServiceExtra
 * @param {T} params
 */
export function getDevicesServiceExtra(params) {
    return __awaiter(this, void 0, void 0, function () {
        var response, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, API({
                            url: DEVICES_END_POINTS.GET_DEVICES_SYNC,
                            params: params,
                            method: 'get',
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
                case 2:
                    e_2 = _a.sent();
                    return [2 /*return*/, e_2];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function getDevicesTypeService(params) {
    return __awaiter(this, void 0, void 0, function () {
        var response, mappedData, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, API({
                            url: DEVICES_END_POINTS.GET_DEVICES_HISTORY,
                            params: params,
                            method: 'get',
                        })];
                case 1:
                    response = _a.sent();
                    mappedData = mapDevicesHistoryResponse(response);
                    return [2 /*return*/, mappedData];
                case 2:
                    e_3 = _a.sent();
                    return [2 /*return*/, e_3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function mapDevicesHistoryResponse(apiResponse) {
    if (!(apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.data))
        return [];
    var rows = [];
    Object.entries(apiResponse.data).forEach(function (_a) {
        var unique_identifier = _a[0], deviceObj = _a[1];
        var device_type = deviceObj.device_type, history = deviceObj.history;
        var rowSpan = history.length;
        history.forEach(function (h, index) {
            rows.push({
                key: "".concat(unique_identifier, "-").concat(index),
                unique_identifier: unique_identifier,
                device_type: device_type,
                member_id: h.member_id,
                senior_name: h.senior_name,
                assigned_date: h.assigned_date,
                unlinked_date: h.unlinked_date,
                status: h.status,
                showDeviceInfo: index === 0,
                deviceRowSpan: index === 0 ? rowSpan : 0,
            });
        });
    });
    return rows;
}
/**
 * @description method to get all the device info along with watch phone number
 * @function getDevicesInformationService
 * @param {any} params
 */
export function getDevicesInformationService(params) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, API({
                        url: DEVICES_END_POINTS.GET_DEVICES_INFORMATION,
                        params: params,
                        method: 'get',
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
